import(/* webpackMode: "eager" */ "/vercel/path0/src/app/(main)/blog/[slug]/error.tsx");
